import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx("span", {
        children: /*#__PURE__*/ _jsxs("picture", {
            children: [
                /*#__PURE__*/ _jsx("source", {
                    type: "image/png",
                    srcSet: "images/apidaeSwap.png, images/home/cake/coin.webp"
                }),
                /*#__PURE__*/ _jsx("img", {
                    src: "images/apidaeSwap.png",
                    loading: "lazy",
                    decoding: "async",
                    width: 198
                })
            ]
        })
    });
};
export default Icon;
